import React, { FC, useContext } from 'react';
import { Formik } from 'formik';

import { AnimatedScreen, LoadingPage, PageHeader } from 'Shared/components';
import { PartnerContext } from 'Admin/utils';

import {
  CommissionForm,
  CommissionFormType,
  CommissionStructure,
} from '../../components';

export const View: FC = () => {
  const { loading, currentPartner } = useContext(PartnerContext);

  if (loading) return <LoadingPage />;

  if (!currentPartner) {
    return null;
  }

  return (
    <AnimatedScreen testId="view-commission">
      <PageHeader heading="Commission" />
      <Formik<CommissionFormType>
        initialValues={{
          effectiveDate: '',
          endDate: '',
          commissionStructure: CommissionStructure.Commission,
          commissionTemplate: '',
        }}
        onSubmit={() => {
          // form is read-only
        }}
      >
        <CommissionForm type="readonly" />
      </Formik>
    </AnimatedScreen>
  );
};
